import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import adminService from '../../services/adminService';
import productService from '../../services/productService';
import commonStyles from '../AdminOrdersPage/AdminOrdersPage.module.scss';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import MediaLibraryModal from '../../components/common/MediaLibraryModal/MediaLibraryModal';

const BACKEND_URL = 'https://huongtramcomoc.vn';

const AdminAboutPage = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [featuredImage, setFeaturedImage] = useState('');
  const [loading, setLoading] = useState(false);
  
  const [modalMode, setModalMode] = useState(null); 
  const quillRef = useRef(null);

  // SLUG QUAN TRỌNG: Phải khớp với database
  const PAGE_SLUG = 'gioi-thieu';

  useEffect(() => {
    productService.getPageContent(PAGE_SLUG).then(res => {
      setTitle(res.data.title || '');
      setContent(res.data.content || '');
      setFeaturedImage(res.data.featured_image_url || '');
    });
  }, []);

  const handleFileSelect = (file) => {
    if (modalMode === 'quill') {
      const editor = quillRef.current.getEditor();
      const range = editor.getSelection();
      const cursorPosition = range ? range.index : editor.getLength();
      editor.insertEmbed(cursorPosition, 'image', `${BACKEND_URL}${file.file_path}`);
    } else if (modalMode === 'featured') {
      setFeaturedImage(file.file_path);
    }
    setModalMode(null);
  };

  const quillImageHandler = useCallback(() => setModalMode('quill'), []);

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, false] }], ['bold', 'italic', 'underline', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'align': []}], ['link', 'image'], ['clean']
      ],
      handlers: { image: quillImageHandler }
    }
  }), [quillImageHandler]);

  const handleSave = () => {
    setLoading(true);
    adminService.updatePageContent(PAGE_SLUG, title, content, featuredImage)
      .then(() => { toast.success("Đã lưu nội dung!"); setLoading(false); })
      .catch(err => { toast.error("Lỗi lưu: " + err); setLoading(false); });
  };

  return (
    <div className={commonStyles.adminPage}>
      <h1>Chỉnh Sửa: Giới Thiệu Công Ty</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Tiêu đề trang</label>
        <input type="text" value={title} onChange={e => setTitle(e.target.value)}
          style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }} />
      </div>

      <div style={{ marginBottom: '30px', border: '1px dashed #ccc', padding: '20px', borderRadius: '4px', background: '#fff' }}>
          <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>Ảnh Banner (Đầu trang)</label>
          {featuredImage ? (
              <div style={{ marginBottom: '10px' }}>
                  <img src={`${BACKEND_URL}${featuredImage}`} alt="Featured" style={{ maxWidth: '100%', height: '200px', objectFit: 'cover', borderRadius: '4px' }} />
                  <br/>
                  <button onClick={() => setFeaturedImage('')} style={{ marginTop: '10px', padding: '5px 10px', background: '#d9534f', color:'white', border:'none', borderRadius:'4px', cursor:'pointer'}}>Gỡ ảnh</button>
              </div>
          ) : <p>Chưa có ảnh banner.</p>}
          <button onClick={() => setModalMode('featured')} style={{ padding: '8px 15px', background: '#007bff', color:'white', border:'none', borderRadius:'4px', cursor:'pointer'}}>
              {featuredImage ? 'Thay đổi ảnh' : 'Chọn ảnh từ thư viện'}
          </button>
      </div>

      <div style={{ background: '#fff', minHeight: '400px', marginBottom: '20px' }}>
        <ReactQuill ref={quillRef} theme="snow" value={content} onChange={setContent} modules={modules} style={{ height: '350px' }} />
      </div>

      <button onClick={handleSave} className={commonStyles.actionButton} disabled={loading} style={{ padding: '12px 30px' }}>
        {loading ? 'Đang lưu...' : 'Lưu Thay Đổi'}
      </button>

      <MediaLibraryModal isOpen={!!modalMode} onClose={() => setModalMode(null)} onFileSelect={handleFileSelect} />
    </div>
  );
};
export default AdminAboutPage;